import React from 'react'
import Page from '../components/Page'

//used for pricacy-policy and terms-of-service pages
export default function SinglePage (props) {
  const {
    title,
    content,
    body,
    bgImage,
    bgVideo,
    alt,
    height,
    width,
    slug
  } = props

  return (
    <React.Fragment>
      <Page {...props}>
        <main id='content'>
          <div className='container single-page'>
            <div className='row'>
              <div className='col-md-8 offset-md-2'>
                {title ? (
                  <h1
                    className='heading1 text-center'
                    dangerouslySetInnerHTML={{ __html: title }}
                  />
                ) : (
                  ''
                )}

                {content ? (
                  <div dangerouslySetInnerHTML={{ __html: content }} />
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
        </main>
      </Page>
    </React.Fragment>
  )
}
